"use client";

import GetCurrentAppConfig from "@/actions/config/get-current-app-config";
import { MainDesktopNavigation } from "@/components/main/header/navigations";
import { useReadingProgress } from "@/hooks/use-reading-progress";

interface DetailPostHeaderProps {
  title?: string;
}

const DetailPostHeader: React.FC<DetailPostHeaderProps> = ({ title }) => {
  const completion = useReadingProgress();
  return (
    <header className="border-y-1 sticky top-0 z-50 h-16 border-black/5 shadow-sm shadow-gray-300">
      <MainDesktopNavigation />
      <span
        style={{
          transform: `translateX(${completion - 100}%)`,
          backgroundColor: GetCurrentAppConfig().color.loader,
        }}
        className={`absolute bottom-0 h-1 w-full`}
      />
    </header>
  );
};

export default DetailPostHeader;
